import React from 'react';
import { ModelTile, ProductTile } from '@hpi-sox/hpstellar-core';

import withPageComponents from '../../page/components/with-page-components';
import useModelPrice from '../../hooks/useModelPrice';
import getModelProps from '../get-model-props';
import TitleSection from '../../shared/components/title-section';
import useTemplateTheme from '../../hooks/useTemplateTheme';
import parseModelProps from '../util';
import MLPJsonLd from './mlp-json-ld';

const modelList = ({ mlpModelList, mlpHeader, titleTag = 'h1' }) => {
    const { models = [], sectionTitle } = mlpModelList || {};
    const { modelPrices } = useModelPrice(models);
    const { css, options } = useTemplateTheme(['options']);
    const { tileType } = options || {};

    const tileClassName = css ? css + '-mlp-tile-title' : 'mlp-tile-title';

    if (models && models.length > 0) {
        return (
            <>
                <TitleSection
                    title={sectionTitle}
                    partnerLogoProps={mlpHeader}
                    typographyVariant={'titleM'}
                    titleTag={titleTag}
                />
                <div className="mlpList">
                    {models.map((model, idx) => {
                        const { modelId } = model;
                        const price = modelPrices[modelId];
                        const key = `${model.title}_${idx}`;

                        // Use React.Fragment with explicit key instead of <> shorthand
                        return (
                            <React.Fragment key={key}>
                                {!options && (
                                    <ModelTile
                                        className="tile"
                                        {...getModelProps(model, price)}
                                        fullHeight
                                        titleTag="h2"
                                    />
                                )}
                                {tileType == 'ProductTile' && (
                                    <ProductTile
                                        className={css ? `${css}-prod-tile` : ''}
                                        hoverColor="#303030"
                                        classes={{
                                            title: tileClassName,
                                        }}
                                        titleLineLimit={3}
                                        translations={{
                                            price: {
                                                tierMsg: '',
                                            },
                                        }}
                                        {...parseModelProps(getModelProps(model, price))}
                                    />
                                )}
                            </React.Fragment>
                        );
                    })}
                </div>
                <MLPJsonLd models={models} modelPrices={modelPrices} listName={sectionTitle || 'HP Product Models'} />
            </>
        );
    }
    return null;
};

export default withPageComponents(modelList, { components: ['mlpModelList', 'mlpHeader'] });
